import React, { useState, useMemo } from "react";

export default function SelectPopup({
  title,
  options,
  value,
  onSelect,
  onClose,
  allowAdd = false
}) {

const [search,setSearch] = useState("");

const filtered = useMemo(()=>{
  return options.filter(o =>
    o.toLowerCase().includes(search.toLowerCase())
  );
},[search,options]);

return(

<div className="popup-overlay">

<div className="popup-box">

<div className="popup-header">
<span>{title}</span>
<button onClick={onClose}>✕</button>
</div>

<input
className="popup-search"
autoFocus
placeholder="Search or type..."
value={search}
onChange={e=>setSearch(e.target.value)}
/>

<div className="popup-list">

{filtered.map((o,i)=>(
<div
key={o}
className="popup-row"
onClick={()=>{
onSelect(o);
onClose();
}}
>
{o}
</div>
))}

{allowAdd && search && !options.includes(search) && (

<div
className="popup-row add-new"
onClick={()=>{
onSelect(search);
onClose();
}}
>
➕ Add "{search}"
</div>

)}

</div>

</div>

</div>

);

}